export default function () {
  $(".qlWrapper ul.ql li").click(function () {
    var skipHeader = $("header").height();
    var $qlink = $(this);
    var sectionID = $qlink.attr("data-sectionid");
    var $targetElement = $(
      '.sectionHeader[data-sectionid="' + sectionID + '"]'
    );
    var target = $targetElement.offset().top;
    var sTop = target - skipHeader;
    $("html, body").animate({ scrollTop: sTop }, 500);
    if (!$targetElement.hasClass("clicked")) {
      $targetElement.click();
    }
  });
}
